import "core-js/modules/es6.function.name";
import Vue from 'vue';
import Vuex from 'vuex';
import Typhoon from "./modules/typhoon";
import Alarm from "./modules/alarm";
import Rainfall from "./modules/rainfall";
import HistoryTyphoon from "./modules/typhoon-history";
import Map from "./modules/map";
import CanvasManage from "./modules/canvas-manage";
import Status from "./modules/stauts";
import Szyb from "./modules/szyb";
import Risks from "./modules/risks"; // import Legend from './modules/legend'

var TIMER; // 设置一个定时器，主要考虑数据自刷新问题

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    // ...GLOBAL_CONFIG,
    isFullScreen: false,
    // 是否全屏
    isRefresh: false,
    // 手动刷新
    emitFullScreenInterval: false,
    // 全屏定时器发射信息
    timeliness: true,
    // 全局时效性,true有效，false无效
    theme: 'nofull',
    // 主题，需求是跟随全屏走
    skin: 'dark',
    // 皮肤，主要是换肤色
    routerStacks: [] // 路由堆栈

  },
  mutations: {
    SET_TIMELINESS: function SET_TIMELINESS(state, status) {
      state.timeliness = status;
    }
  },
  getters: {
    getMapConfig: function getMapConfig(state) {
      return function (name, type) {
        // 优先处理Mapconfig不存在的场景
        if (!state.mapConfig) return type;
        return state.mapConfig[name] || type;
      };
    }
  },
  modules: {
    Typhoon: Typhoon,
    // Menu,,
    Map: Map,
    Alarm: Alarm,
    HistoryTyphoon: HistoryTyphoon,
    Rainfall: Rainfall,
    CanvasManage: CanvasManage,
    Status: Status,
    Szyb: Szyb,
    Risks: Risks // ,
    // Legend

  },
  actions: {
    // 全局全屏监听
    setGlobalFullScreen: function setGlobalFullScreen(_ref) {
      var state = _ref.state;
      state.isFullScreen = !state.isFullScreen;
      state.theme = state.isFullScreen ? 'full' : 'nofull';

      if (state.isFullScreen) {
        // 设置定时器
        TIMER = setInterval(function () {
          state.emitFullScreenInterval = !state.emitFullScreenInterval; // 信号发射器，true或者false
        }, (state.loopTime || 120) * 1000); // }, 1500)
      } else {
        if (TIMER) clearInterval(TIMER);
      }
    },
    // 全局刷新按钮
    emitFresh: function emitFresh(_ref2) {
      var state = _ref2.state;
      state.isRefresh = !state.isRefresh;
    }
  }
});